import _difference from 'lodash/difference';
import _omit from 'lodash/omit';
export const sanitizeIdFromATGLConfig = (inputData, componentConfigMap, keysToRemove: string[] = []) => {
  const sanitizedComponentConfigMap = Object.keys(componentConfigMap).reduce((acc, key) => {
    if (keysToRemove.includes(key)) return acc;
    return {
      ...acc,
      [key]: {
        ...componentConfigMap[key],
        node: _difference(componentConfigMap[key].node, keysToRemove)
      }
    };
  }, {});
  return {
    componentConfigMap: sanitizedComponentConfigMap,
    inputData: _omit(inputData, keysToRemove)
  };
};